import { type ClassValue, clsx } from 'clsx';

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

/**
 * True when the event's composed path passes through `node`. Use it over
 * `contains(event.target)`, which a shadow root retargets to the host.
 */
export function eventPathContains(event: Event, node: Node | null): boolean {
  if (!node) return false;
  return event.composedPath().includes(node);
}

/** Options controlling {@link resolveLinkTarget}'s precedence rules. */
export interface ResolveLinkTargetOptions {
  /** In-app config page: always a new tab so the admin never navigates away. */
  previewMode: boolean;
  /** Open same-hostname links in a new tab too, so visitors keep the conversation. */
  openLinksInNewTab?: boolean;
}

/** Decide where a chat link opens: `_self` only for a same-hostname http(s) link. */
export function resolveLinkTarget(
  href: string | undefined | null,
  { previewMode, openLinksInNewTab }: ResolveLinkTargetOptions,
): '_blank' | '_self' {
  if (previewMode || !href) return '_blank';
  if (/^(mailto:|tel:)/i.test(href)) return '_blank';
  try {
    const url = new URL(href, window.location.href);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return '_blank';
    if (url.hostname !== window.location.hostname) return '_blank';
    return openLinksInNewTab ? '_blank' : '_self';
  } catch {
    return '_blank';
  }
}
